import { Paragraph2 } from '@cian/ui-kit';
import * as React from 'react';
import { Link } from '../../../common/Link';
import { IBalanceProps } from '../../types';
import { PaymentStatusContainer } from '../PaymentStatus';
import { MoneySourceContainer } from '../MoneySource';

export const BalanceDesktop = (props: IBalanceProps) => {
  const { withMoneySource, showBalance, withPay, balanceString, payUrl, handleDepositLinkClick } = props;

  return (
    <div>
      {withMoneySource && <MoneySourceContainer />}

      {showBalance && !!balanceString && (
        <Paragraph2 as="div">
          <div>Баланс:&nbsp;{balanceString}</div>

          {withPay && (
            <Link
              data-name="FillBalance"
              href={payUrl}
              target="_blank"
              rel="noreferrer"
              onClick={handleDepositLinkClick}
            >
              Пополнить
            </Link>
          )}
        </Paragraph2>
      )}

      {showBalance && !balanceString && <Paragraph2>Баланс</Paragraph2>}

      <PaymentStatusContainer />
    </div>
  );
};
